export default __webpack_public_path__ + "static/media/PaypalButton.3cdf7fa2.svg";